import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { EndPoints } from "../../../../endPoints/endPoints";
import { IPerson } from "../../../../interfaces/IPerson";
import { IAirStaffResponse } from "./IAirStaffResponse";

export const airStaffApi = createApi({
  reducerPath: "airStaff",
  baseQuery: fetchBaseQuery({
    baseUrl: EndPoints.AIRSTAFF,
  }),
  tagTypes: ["air-staff", "air-person"],
  endpoints: (builder) => ({
    getFilteredPersons: builder.query<IAirStaffResponse, string>({
      query(searchParams) {
        return {
          url: `/pagination?${searchParams}`
        }
      },
      providesTags: ["air-staff"],
    }),
    getAllPersons: builder.query<IPerson[], void>({
      query() {
        return {
          url: "",
          method: "GET",
          credentials: "include",
        };
      },
      providesTags: ["air-staff"],
    }),
    addPerson: builder.mutation<any, Omit<IPerson, "id">>({
      query(body) {
        return {
          url: "",
          method: "POST",
          credentials: "include",
          body,
        };
      },
      invalidatesTags: ["air-staff"],
    }),
    getPerson: builder.query<IPerson, number>({
      query(id) {
        return {
          url: `/${id}`,
          method: "GET",
          credentials: "include",
        };
      },
      providesTags: ["air-person"]
    }),
    editPerson: builder.mutation<IPerson, IPerson>({
      query({ id, ...body }) {
        return {
          url: `/${id}`,
          method: "PUT",
          credentials: "include",
          body,
        };
      },
      invalidatesTags: ["air-staff", "air-person"],
    }),
    deletePerson: builder.mutation<string, number>({
      query(id) {
        return {
          url: `/${id}`,
          method: "DELETE",
          credentials: "include",
        };
      },
      invalidatesTags: ["air-staff"],
    }),
  }),
});

export const {
  useAddPersonMutation,
  useDeletePersonMutation,
  useEditPersonMutation,
  useGetAllPersonsQuery,
  useGetPersonQuery,
  useGetFilteredPersonsQuery,
} = airStaffApi;
